import { get, size } from 'global/lib/lodash';
import useNavSettings from 'global/hooks/useNavSettings';
import useRetrieveData from '../hooks/useRetrieveData';

export const getStatus = (edition) => {
  const status = get(edition, 'status', 'active');

  const getTitle = () => {
    return status;
  };

  return {
    status,
    title: getTitle(),
  };
};

export const useAccessEdition = (editionId) => {
  const { nav } = useNavSettings();

  const ed = useRetrieveData({ url: `/editions/${editionId}` }, { waitFor: !editionId ? null : editionId, build: ['editions'], showAlert: false });

  if (!nav.library) {
    return false;
  }

  return !!size(ed.data) ? true : false;
};
